export default __webpack_public_path__ + "static/philippines-d1130498cc4d51e1f6e352b748c874fd.svg";